// Admin API wrapper. Token is stored in localStorage.
const TOKEN_KEY = 'tc_admin_token';

export const getToken = () => localStorage.getItem(TOKEN_KEY) || '';
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

function authHeaders() {
  const t = getToken();
  return t ? { Authorization: `Bearer ${t}` } : {};
}

async function readJson(r, fallback) {
  const data = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(data.error || fallback);
  return data;
}

export async function login(password, username = 'admin') {
  const r = await fetch('/api/login', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ username, password }),
  });
  const data = await readJson(r, '????');
  setToken(data.token);
  return data.token;
}

export async function checkAuth() {
  if (!getToken()) return false;
  try {
    const r = await fetch('/api/me', { headers: authHeaders() });
    return r.ok;
  } catch {
    return false;
  }
}

export async function saveContent(content) {
  const r = await fetch('/api/content', {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...authHeaders() },
    body: JSON.stringify(content),
  });
  return readJson(r, '????');
}

export async function uploadImage(file) {
  const fd = new FormData();
  fd.append('file', file);
  const r = await fetch('/api/upload', { method: 'POST', headers: authHeaders(), body: fd });
  return readJson(r, '????');
}

export async function adminLeadsList(status = 'all') {
  const r = await fetch(`/api/admin/leads?status=${encodeURIComponent(status)}`, { headers: authHeaders(), cache: 'no-store' });
  return readJson(r, '??????');
}

export async function markLead(id, status) {
  const r = await fetch(`/api/admin/leads/${id}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...authHeaders() },
    body: JSON.stringify({ status }),
  });
  return readJson(r, '????');
}

export async function deleteLead(id) {
  const r = await fetch(`/api/admin/leads/${id}`, { method: 'DELETE', headers: authHeaders() });
  return readJson(r, '????');
}

export async function adminCoursewareList() {
  const r = await fetch('/api/admin/courseware', { headers: authHeaders(), cache: 'no-store' });
  return readJson(r, '??????');
}

export async function adminCreateCourseware({ title, description, file, packageId, importMode }) {
  const fd = new FormData();
  fd.append('title', title || '');
  fd.append('description', description || '');
  fd.append('importMode', importMode || 'lesson');
  if (packageId) fd.append('packageId', packageId);
  fd.append('file', file);
  const r = await fetch('/api/admin/courseware', { method: 'POST', headers: authHeaders(), body: fd });
  return readJson(r, '上传课件失败');
}
export async function adminUpdateCourseware(id, { title, description, status, file, packageId }) {
  const fd = new FormData();
  fd.append('title', title || '');
  fd.append('description', description || '');
  fd.append('status', status || 'published');
  if (packageId !== undefined) fd.append('packageId', packageId || '');
  if (file) fd.append('file', file);
  const r = await fetch(`/api/admin/courseware/${encodeURIComponent(id)}`, { method: 'PUT', headers: authHeaders(), body: fd });
  return readJson(r, '??????');
}

export async function adminDeleteCourseware(id) {
  const r = await fetch(`/api/admin/courseware/${encodeURIComponent(id)}`, { method: 'DELETE', headers: authHeaders() });
  return readJson(r, '删除课程失败');
}

export async function adminReorderCourseware(orderedIds) {
  const r = await fetch('/api/admin/courseware-reorder', {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...authHeaders() },
    body: JSON.stringify({ orderedIds }),
  });
  return readJson(r, '排序失败');
}

export async function adminPackageList() {
  const r = await fetch('/api/admin/course-packages', { headers: authHeaders(), cache: 'no-store' });
  return readJson(r, '获取课程包失败');
}

export async function adminCreatePackage(payload) {
  const r = await fetch('/api/admin/course-packages', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...authHeaders() },
    body: JSON.stringify(payload),
  });
  return readJson(r, '保存课程包失败');
}

export async function adminUpdatePackage(id, payload) {
  const r = await fetch(`/api/admin/course-packages/${encodeURIComponent(id)}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...authHeaders() },
    body: JSON.stringify(payload),
  });
  return readJson(r, '更新课程包失败');
}

export async function adminDeletePackage(id) {
  const r = await fetch(`/api/admin/course-packages/${encodeURIComponent(id)}`, { method: 'DELETE', headers: authHeaders() });
  return readJson(r, '删除课程包失败');
}

export async function adminReorderPackages(orderedIds) {
  const r = await fetch('/api/admin/course-packages-reorder', {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...authHeaders() },
    body: JSON.stringify({ orderedIds }),
  });
  return readJson(r, '排序失败');
}

export async function adminAuthorizationList(keyword = '') {
  const query = keyword ? `?q=${encodeURIComponent(keyword)}` : '';
  const r = await fetch(`/api/admin/course-authorizations${query}`, { headers: authHeaders(), cache: 'no-store' });
  return readJson(r, '获取授权账号失败');
}
export async function adminCreateAuthorization(payload) {
  const r = await fetch('/api/admin/course-authorizations', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...authHeaders() },
    body: JSON.stringify(payload),
  });
  return readJson(r, '保存授权账号失败');
}

export async function adminUpdateAuthorization(id, payload) {
  const r = await fetch(`/api/admin/course-authorizations/${encodeURIComponent(id)}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...authHeaders() },
    body: JSON.stringify(payload),
  });
  return readJson(r, '更新授权账号失败');
}